import { useQuery } from 'react-query';

import { categoryService } from 'categories/services';
import { ICategory } from 'categories/types';
import { useInfiniteQuery } from 'core/hooks';
import { GetOneResult } from 'core/types';

export const useGetCategories = (
  requestPayload,
  options: { enabled?: boolean; fetchAllPages?: boolean } = {}
) =>
  useInfiniteQuery<ICategory>(categoryService.getCategories, 'categories', requestPayload, options);

export const useGetCategory = (
  criteria: Record<string, unknown>,
  enabled = true
): GetOneResult<ICategory> => {
  const requestPayload = {
    filters: criteria,
  };

  const { data, isLoading, isFetching, isError } = useQuery(
    ['category', criteria],
    ({ signal }) => categoryService.getCategories(requestPayload, signal),
    {
      keepPreviousData: false,
      enabled,
    }
  );

  return {
    record: data?.records?.[0] ?? null,
    isLoading,
    isFetching,
    isError,
  };
};
